import { useState } from 'react';
/**
 * One `Idempotency-Key` per intended change: every submit of the same change - a double click,
 * a retry after a lost answer - repeats it, so nothing happens twice; `renew` after a success,
 * where a form or button stays for the next change. Several changes at once (one per chosen
 * row) take one key each: `${key}.${index}`.
 */
export function useIdempotencyKey() {
    const [key, setKey] = useState(() => crypto.randomUUID());
    return [key, () => setKey(crypto.randomUUID())];
}
//# sourceMappingURL=idempotency.js.map